import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface Operator {
  id: string;
  email: string;
  name: string;
}

interface AuthState {
  token: string | null;
  operator: Operator | null;
  setSession: (token: string, operator: Operator) => void;
  logout: () => void;
}

/** Operator session. Two people use this, so a 12 h token in storage is enough. */
export const useAuth = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      operator: null,
      setSession: (token, operator) => set({ token, operator }),
      logout: () => set({ token: null, operator: null }),
    }),
    { name: 'firmio-console-auth' },
  ),
);
